// src/component/Header/index.jsx (更新版本)
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Button, Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import './index.css';

const Header = () => {
  const { isAuthenticated, logout, user } = useAuth();

  const handleLogout = () => {
    logout();
    // 退出后跳转到登录页面
    window.location.href = '/auth';
  };

  return (
    <header className="app-header">
      <nav className="navbar">
        <div className="nav-brand">
          <Link to="/">我的博客</Link>
        </div>
        <ul className="nav-menu">
          {/* 如果未登录，隐藏导航链接 */}
          {isAuthenticated ? (
            <>
              <li><Link to="/">首页</Link></li>
              <li><Link to="/about">关于我</Link></li>
              <li><Link to="/archive">归档</Link></li>
              <li><Link to="/write">写文章</Link></li>
              <li style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Avatar 
                  size="small" 
                  icon={<UserOutlined />} 
                  src={user?.avatar} 
                  style={{ backgroundColor: '#dc2626' }} // 使用红色主题
                />
                <Button 
                  type="link" 
                  onClick={handleLogout}
                  style={{ 
                    color: '#7f1d1d', // 使用深红色以匹配主题
                    padding: 0,
                    fontWeight: '500',
                    fontSize: '1rem',
                    textDecoration: 'underline',
                    textUnderlineOffset: '3px'
                  }}
                >
                  退出 ({user?.name || '用户'})
                </Button>
              </li>
            </>
          ) : (
            <li><Link to="/auth" style={{ color: '#7f1d1d', fontWeight: '500' }}>登录</Link></li>
          )}
        </ul>
      </nav>
    </header>
  );
};

export default Header;